import React, {useCallback, useEffect, useMemo, useState} from 'react';
import {formatNumber} from '../../helpers/formatHelper';
import {findRangePrice} from '../../helpers/rangePriceHelper';
import {login} from '../../helpers/login';
import {getDetailProduct, addCart} from "../services/detailsService";
import {cartShowCount, orderShowCount} from "../../helpers/HeaderShow";


function MainController(props) {
    const id = document.getElementById('product-detail-app').getAttribute("data-id");
    const [product, setProduct] = useState({});
    const [quantityKW, setQuantityKW] = useState(0);
    const [price, setPrice] = useState(0);
    const [listProductPropertiesSelect,setListProductPropertiesSelect] = useState([]);
    const [quantityBuy, setQuantityBuy] = useState(1);
    const [productSimilarSelect, setProductSimilarSelect] = useState(0);
    const [err, setErr] = useState("");
    const [disable, setDisable] = useState(true);
    const [isLoad, setIsload] = useState(false);
    const [isLogin, setIsLogin] = useState(false);

    useEffect(() => {
        getDetailProduct({id: id}, (rs) => {
            setIsload(true);
            setProduct(rs);
            setQuantityKW(rs.quantityKW);
            setPrice(rs.showPrice);
            setIsLogin(rs.isLogin);
            setDisable(false);
            if (rs.productProperties.length == 0 && rs.productSimilar.length == 1) {
                setProductSimilarSelect(rs.productSimilar[0].id);
            }
        });
    }, []);

    useEffect(() => {
        if (product?.productProperties?.length > 0) {
            product?.productProperties.forEach(function (item) {
                let listV = item?.productPropertieValue ?? [];
                if (listV.length === 1) {
                    let e = {
                        currentTarget: {
                            name: item.id,
                            value: listV[0].id
                        }
                    }
                    method.selectProperties(e);
                }
            })
        }
    }, [product])

    useEffect(function(){
        let productRangePrice = product?.productRangePrice || []
        let productSimilar = product?.productSimilar || []
        let similar = productSimilar.find( x => x.id == productSimilarSelect);
        // SP không có giá sỉ: giữ cách hiện giá sẵn có
        if (!(Array.isArray(productRangePrice) && productRangePrice.length > 0)) return;
        let rangePrice = findRangePrice(productRangePrice, quantityBuy)
        if (rangePrice){
            setPrice(formatNumber(rangePrice.price));
            return;
        }
        setPrice(similar ? formatNumber(similar.price) : product.showPrice);
    },[product,productSimilarSelect,quantityBuy])

    const canBy = useMemo(() => {
        return quantityKW >= quantityBuy
    }, [quantityKW, quantityBuy])

    // Sản phẩm bị khóa bán (IsAllowSale = false) thì ẩn mọi nút mua/đặt hàng
    const isAllowSale = useMemo(() => {
        return product?.isAllowSale !== false
    }, [product])

    const method = {
        isValid: (checkQuantity = true) => {
            let isCheck = true;
            if (productSimilarSelect > 0) {
                isCheck = isCheck && true;
                setErr("");
            } else {
                isCheck = isCheck && false;
                setErr("Vui lòng chọn phân loại hàng");
            }
            if (checkQuantity && isCheck) {
                if (quantityBuy <= quantityKW) {
                    isCheck = isCheck && true;
                    setErr("");
                } else {
                    isCheck = isCheck && false;
                    setErr("Số lượng mua vượt số lượng hàng có sẵn, vui lòng chọn lại");
                }
            }

            return isCheck;
        },
        showModalSuccess: (content) => {
            $("#modal-detail-p-success").addClass("show");
            $("#modal-detail-p-content").html(content);
            setTimeout(() => {
                $("#modal-detail-p-success").removeClass("show");
            }, 2000);
        },
        saveCart: async (e) => {
            new Promise(function (resolve, reject) {
                resolve(login());
            }).then((value) => {
                if (value == "true" && method.isValid()) {
                    let param = {
                        ProductId: id,
                        ProductSimilarId: productSimilarSelect,
                        Quantity: quantityBuy,
                        type: 1
                    };
                    addCart(param, (rs) => {
                        if (rs.statusCode == 200) {
                            cartShowCount(rs.data);
                            method.showModalSuccess("Thêm sản phẩm vào giỏ hàng thành công");
                        } else {
                            setErr(rs.err);
                        }
                    });
                }
            })
        },
        saveOrder: (e) => {
            new Promise(function (resolve, reject) {
                resolve(login());
            }).then((value) => {
                if (value == "true" && method.isValid()) {
                    let param = {
                        ProductId: id,
                        ProductSimilarId: productSimilarSelect,
                        Quantity: quantityBuy,
                        type: 2
                    };
                    addCart(param, (rs) => {
                        if (rs.statusCode == 200) {
                            window.location.href = "/cart";
                        } else {
                            setErr(rs.err);
                        }
                    });
                }
            })
        },
        // Đặt hàng trước: bỏ sản phẩm vào giỏ (không kiểm tra tồn kho) rồi đưa khách sang giỏ hàng,
        // khách tích chọn sản phẩm và bấm "Đặt hàng trước" ở đó.
        savePreOrder: (e) => {
            new Promise(function (resolve, reject) {
                resolve(login());
            }).then((value) => {
                if (value == "true" && method.isValid(false)) {
                    let param = {
                        ProductId: id,
                        ProductSimilarId: productSimilarSelect,
                        Quantity: quantityBuy,
                        type: 2
                    };
                    addCart(param, (rs) => {
                        if (rs.statusCode == 200) {
                            window.location.href = "/cart";
                        } else {
                            setErr(rs.err);
                        }
                    });
                }
            })
        },
        selectProperties: async (e) => {
            let listProductSimilar = product?.productSimilar ?? [];
            let listProductProperties = product?.productProperties ?? [];

            let obj = {
                id: e.currentTarget.name,
                value: e.currentTarget.value
            }
            let currentSelect = [...listProductPropertiesSelect];
            let checkIndex = currentSelect.findIndex(x => x.id == obj.id);
            if (checkIndex > -1) {
                currentSelect.splice(checkIndex, 1);
            }
            currentSelect.push(obj);
            if (currentSelect.length === listProductProperties.length) {
                let index = listProductSimilar.findIndex(x => {
                    if (x.productPropertieValue != null && x.productPropertieValue.length > 0) {
                        let a = x.productPropertieValue.split(",");
                        let isCheck = true;
                        currentSelect.forEach(s => {
                            let c = a.findIndex(x => x == s.value);
                            isCheck = isCheck && (c > -1);
                        })
                        return isCheck;
                    }
                })
                if (index > -1) {
                    let productSimilar = listProductSimilar[index];
                    setPrice(formatNumber(productSimilar?.price));
                    setQuantityKW(productSimilar?.quantityWh);
                    setProductSimilarSelect(productSimilar?.id);
                    setErr("");
                } else {
                    setProductSimilarSelect(0);
                }
            }
            setListProductPropertiesSelect(currentSelect);
        },
        changeQuantityBuy: (e) => {
            if (method.isValid(false)) {
                let quantity = Math.floor(e.currentTarget.value);
                setQuantityBuy(quantity);
                if (quantityKW >= quantity) {
                    setErr("");
                } else {
                    setErr("Số lượng vượt quá hàng tồn kho. Vui lòng đặt hàng trước");
                }
            }
        },
        clickQuantityBuy: (type) => {
            if (method.isValid(false)) {
                if (type === 1) {
                    let q = quantityBuy - 1;
                    if (q < 1) {
                        setQuantityBuy(1);
                    } else {
                        setQuantityBuy(q);
                    }
                    if (quantityKW >= q) {
                        setErr("");
                    } else {
                        setErr("Số lượng vượt quá hàng tồn kho. Vui lòng đặt hàng trước");
                    }
                } else if (type === 2) {
                    let q = quantityBuy + 1;
                    setQuantityBuy(q);
                    if (quantityKW >= q) {
                        setErr("");
                    } else {
                        setErr("Số lượng vượt quá hàng tồn kho. Vui lòng đặt hàng trước");
                    }
                }
            }
        },
        isChecked: useCallback((name, value) => {
            let index = listProductPropertiesSelect.findIndex(x => x.id == name && x.value == value);
            console.log("change",index,name, value)
            return index > -1;
        },[listProductPropertiesSelect])
    };

    return {method, state: {canBy, isAllowSale, product, quantityBuy, quantityKW, price, err, disable, isLoad, isLogin}}
}

export default MainController;